import React, { useEffect, useState } from 'react';
import ActivityLoader from '../../Common/ActivityLoader';
import BsModal from '../../Common/BsModal';
import { useConfig } from '../../../DataStore/ConfigContext';
import ajaxConfig from '../../../util/remote/ajaxConfig';
import { useTheme } from '../../../DataStore/ThemeContext';
import Notification from '../../Common/Notification';

const AlertDeleteUnit = () => {

    const [loading, setLoading] = useState(false);
    const {setNotify} = useTheme();

    const { setDeleteUnit, deleteUnit } = useConfig();

    const handleClose = () => setDeleteUnit({ show: false, unit: null });


   if (!deleteUnit.unit) return null;
  
   

    const confirm = async()=>{
        setLoading(true);
        const server_response = await ajaxConfig.deleteSubjectUnit(deleteUnit.unit.unit_id);
        setLoading(false);
        if(server_response.status === "OK"){
            deleteUnit.callback();
            setNotify(<Notification type='success' message={server_response.message}/>)
        }else{
            setNotify(<Notification type='danger' message={server_response.message}/>)

        }
        handleClose();
    }

    return (
        <BsModal
            show={deleteUnit.show}
            onClose={handleClose}
            title="Delete Study Unit"
            footer={
                <>
                    {loading && <ActivityLoader />}
                    {!loading && <>
                    <button className="btn btn-secondary" onClick={handleClose}>
                        Cancel
                    </button>
                    <button className="btn btn-danger" onClick={confirm}>
                        Confirm Delete
                    </button>
                    </>}
                </>
            }
        >


            {deleteUnit.unit && <div className="d-flex justify-content-center align-items-center flex-column">
                <i 
                className="fa fa-question-circle text-danger" 
                style={{ fontSize: "40px", lineHeight: "1", marginTop: "20px" }}
                ></i>
                <h5 className='mt-1 text-dark text-center' style={{fontSize: '17px'}}>Please confirm that you want to delete this study unit, <i>{deleteUnit.unit.title}</i>.</h5>

        
           
            </div>}
          

        </BsModal>
    );
};

export default AlertDeleteUnit;
